import ReviewPDF from './ReviewPDF';

const ReviewPDFWrapper = () => <ReviewPDF />;

export default ReviewPDFWrapper;
